import TimelineRecordAuthorWithAccessCheck from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/TimelineRecordAuthorWithAccessCheck';
import { PageContentProcessTabs } from 'framework/ViewTypes/components';
import { Timeline } from 'framework/ViewTypes/embeddable';
import type { TimelineConfig, TimelineItem, TimelineSourceRecord } from 'framework/ViewTypes/embeddable';

type PlaceholderTimelineItem = TimelineItem<'PLACEHOLDER'> & TimelineSourceRecord<'PLACEHOLDER'>;

const timelineConfig: TimelineConfig<PlaceholderTimelineItem> = {
  RecordAuthor: TimelineRecordAuthorWithAccessCheck,
  types: {
    PLACEHOLDER: {},
  },
};

const PositionFillRequestTimelinePanel = () => (
  <PageContentProcessTabs
    tabs={[
      {
        id: 'timeline',
        name: 'Timeline',
        panel: <Timeline items={[]} config={timelineConfig} />,
      },
    ]}
  />
);

export default PositionFillRequestTimelinePanel;
